import { useState } from "react";
import React from "react";
import { Menu } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import Dropdown from "../dropdown/dropdown-menu";
function LanguageMenu() {
  const { t } = useTranslation();
  const html = document.getElementsByTagName("html")[0].dir;

  const languages = [
    {
      name: "English",
      flag: "/assets/flags/united-kingdom.png",
      locale: "en",
      href: "/en",
    },
    {
      name: "Español",
      flag: "/assets/flags/flag.png",
      locale: "es",
      href: "/es",
    },
    {
      name: "Français",
      flag: "/assets/flags/france.png",
      locale: "fr",
      href: "/fr",
    },
    {
      name: "العربية",
      flag: "/assets/flags/flag-1.png",
      locale: "ar",
      href: "/ar",
    },
    {
      name: "Türkçe",
      flag: "/assets/flags/turkey.png",
      locale: "tr",
      href: "/tr",
    },
    {
      name: "中文 (简体)",
      flag: "/assets/flags/china.png",
      locale: "zh-cn",
      href: "/zh-cn",
    },
    {
      name: "中文 (繁體)",
      flag: "/assets/flags/china.png",
      locale: "zh-tw",
      href: "/zh-tw",
    },
  ];

  const getLanguageFromUrl = () => {
    const path = window.location.pathname;
    const match = path.match(
      /\/(en-US|en|es|fr|de|it|pt|ja|ru|ko|zh-cn|zh-tw|ar|bg|ca|nl|el|hi|id|ms|pl|sv|th|tr|uk|vi)/
    );
    return match ? match[1] : "en";
  };
  let index = languages.findIndex(
    (item) => item.locale === getLanguageFromUrl()
  );
  const [selected, setSelected] = useState(languages[index]);
  return (
    <>
      <Dropdown
        menuClass="!w-44 py-2"
        direction={html === "rtl" ? "left" : "right"}
        iconClass="border border-secondary-80 relative cursor-pointer rounded-full text-grey-900 focus:outline-none"
        icon={
          <Menu.Button className="flex items-center gap-2 2xl:p-3 md:p-2.5 p-0.5">
            <figure className="md:w-6 md:h-6 sm:w-10 sm:h-10 w-9 h-9 flex items-center justify-center rounded-full bg-secondary-80">
              <img
                src={selected?.flag}
                alt="flag"
                height={24}
                width={24}
                className="w-full h-full"
              />
            </figure>
            <span className="text-grey-900 text-sm hidden md:block">
              {selected?.name || t("English")}
            </span>
            <svg
              width="14"
              height="7"
              viewBox="0 0 14 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`${
                html === "rtl" ? "mr-4" : "ml-4"
              } h-3 w-3 text-secondary-450 hidden md:block`}
            >
              <path
                d="M12.2802 0.966797L7.93355 5.31346C7.42021 5.8268 6.58022 5.8268 6.06688 5.31346L1.72021 0.966797"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Menu.Button>
        }
        options={languages.map((lang) => ({
          href: `${lang.href}${window.location.pathname.replace(
            /\/(en-US|en|es|fr|de|it|pt|ja|ru|ko|zh-cn|zh-tw|ar|bg|ca|nl|el|hi|id|ms|pl|sv|th|tr|uk|vi)/,
            ""
          )}`,
          value: lang.name,
          icon: (
            <img
              src={lang.flag}
              alt="flag"
              height={24}
              width={24}
              className="h-5 w-5 flex-shrink-0 rounded-full bg-secondary-80"
            />
          ),
        }))}
      />
    </>
  );
}
export default LanguageMenu;
